import { render } from "./LoaderBoard.vue?vue&type=template&id=7d3df758"
const script = {}
script.render = render

export default script